import React from 'react'
import PropTypes from 'prop-types'
import { Button, Input } from 'reactstrap'

const UrlPagination = ({ pagination, loading = false }) => (
  <div className='d-flex justify-content-between align-items-center flex-wrap mt-3' aria-label='Pagination'>
    <span>Page { pagination.page } of { pagination.totalPages } · Total { pagination.total }</span>
    <div className='d-flex align-items-center flex-wrap' style={{ gap: 6 }}>
      <Input className='mr-2' type='select' aria-label='Rows per page' value={ pagination.pageSize }
        onChange={ (event) => pagination.setPageSize(Number(event.target.value)) }>
        { [ 10, 20, 50, 100 ].map((size) => <option key={ size } value={ size }>{ size } / page</option>) }
      </Input>
      <Button disabled={ loading || pagination.page <= 1 } onClick={ () => pagination.setPage(pagination.page - 1) }>Previous</Button>
      <Button disabled={ loading || pagination.page >= pagination.totalPages } onClick={ () => pagination.setPage(pagination.page + 1) }>Next</Button>
    </div>
  </div>
)

UrlPagination.propTypes = { pagination: PropTypes.object.isRequired, loading: PropTypes.bool }

export default UrlPagination
